import React from 'react'
import Bredcrumb from '../Common/Bredcrumb'

const LatestUpdates = () => {
  return (
    <>
      <Bredcrumb title="Latest Updates" />
      <section className='mt-4'>
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 mb-1-9 mb-lg-0">
                        <ul>
                          <li className='border-bottom py-2'><a class="text-dark" href="/"><b>01 Apr 2024</b> <br />Admissions are open for the session 2024-25 in M.Pharm, B.Pharm & D.Pharm. Feel free to contact us at +91 9935844704, +91 9415929663, and +91 9305864359</a></li>
                          <li className='border-bottom py-2'><a class="text-dark" href="http://www.aicte-india.org" target='blank'><b>22 July 2023</b> <br />AICTE FEEDBACK AND APPROVALS Feedback facility of student and Faculty available in the AICTE Web portal http://www.aicte-india.org</a></li>
                          <li className='border-bottom py-2'><a class="text-dark" href="/"><b>22 July 2023</b><br /> Hurry UP!!! ADMISSION in B. PHARM. through CUET- UG Counselling…Ist Round seat allotment starts on 19/09/2023…Contact for any query 9935844704, 9415929663</a></li>
                          <li className='border-bottom py-2'><a class="text-dark" href="/"><b>Hurry UP!!!</b> <br />ADMISSION in B. PHARM. through CUET- UG Counselling…Ist Round seat allotment starts on 19/09/2023…Contact for any query 9935844704, 9415929663</a></li>
                          <li className='border-bottom py-2'><a class="text-dark" href="http://www.aicte-india.org" target='blank'><b>AICTE FEEDBACK</b> <br />AND APPROVALS Feedback facility of student and Faculty available in the AICTE Web portal http://www.aicte-india.org</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default LatestUpdates
